module.exports = __webpack_public_path__ + "img/Succes_Gw.9fd35c86.png";